import { useSelector } from "react-redux";


const InfluencerLeads = () => {
//   const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        <iframe src= {`https://iiplwork.retool.com/embedded/public/e39ab459-6cc7-484d-8f8e-8c06541a21dc`}
        className="iframe-style"></iframe>
    </div>
  )
};

export default InfluencerLeads;